import { createEntityAdapter } from '@ngrx/entity';
import { SocieteCaracteristiqueEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<SocieteCaracteristiqueEntityState>;

export const adapter = createEntityAdapter<SocieteCaracteristiqueEntityState>({
  selectId: o => o.idSocieteCaracteristique
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const societeCaracteristiqueFeatureKey = 'societeCaracteristique';
